const CENTER_MODAL_ANIMATION_TYPE = 'center';
const BOTTOM_MODAL_ANIMATION_TYPE = 'bottom';
const LEFT_MODAL_ANIMATION_TYPE = 'left';
const RIGHT_MODAL_ANIMATION_TYPE = 'right';
const NONE_MODAL_ANIMATION_TYPE = 'none';

const DEFAULT_MODAL_ANIMATION_TYPE = CENTER_MODAL_ANIMATION_TYPE;

const MODAL_ANIMATION_TYPES = [
    CENTER_MODAL_ANIMATION_TYPE,
    BOTTOM_MODAL_ANIMATION_TYPE,
    LEFT_MODAL_ANIMATION_TYPE,
    RIGHT_MODAL_ANIMATION_TYPE,
    NONE_MODAL_ANIMATION_TYPE
];

export {
    DEFAULT_MODAL_ANIMATION_TYPE,
    CENTER_MODAL_ANIMATION_TYPE,
    BOTTOM_MODAL_ANIMATION_TYPE,
    LEFT_MODAL_ANIMATION_TYPE,
    RIGHT_MODAL_ANIMATION_TYPE,
    NONE_MODAL_ANIMATION_TYPE,
    MODAL_ANIMATION_TYPES
};
